export default "__VITE_ASSET__255f9966__"